import React from 'react';

export const CheckmarkSolidCircle = ({
  color,
  checkMarkColor,
  ...props
}: React.SVGProps<SVGSVGElement> & { color: string; checkMarkColor?: string }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
      <g data-name="icon - checkmark - 24px">
        <path style={{ fill: 'none' }} d="M0 0h24v24H0z" />
        <g data-name="↳color" transform="translate(3 3)" style={{ fill: color, stroke: color, strokeWidth: '.75px' }}>
          <rect width="18" height="18" rx="9" style={{ stroke: 'none' }} />
          <rect x=".375" y=".375" width="17.25" height="17.25" rx="8.625" style={{ fill: 'none' }} />
        </g>
        <path
          data-name="checkmark - path"
          d="M10.016 54.04a.537.537 0 0 0-.757.05l-5.717 6.536-2.614-2.79a.537.537 0 0 0-.783.735l3.02 3.222a.538.538 0 0 0 .392.169h.009a.535.535 0 0 0 .4-.183l6.101-6.979a.537.537 0 0 0-.051-.76z"
          transform="translate(6.901 -45.934)"
          style={{ fill: checkMarkColor ?? '#fff', stroke: checkMarkColor ?? '#fff', strokeWidth: '.2px' }}
        />
      </g>
    </svg>
  );
};
